/* eslint-disable @typescript-eslint/default-param-last */
import { IModalAction } from "@/types/modal.types";
import {
  END_INTERVIEW_FOR_ALL,
  HIDE_MODAL,
  HIDE_NOTIFICATION,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  SHOW_MODAL,
  SHOW_NOTIFICATION,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const modalReducer = (state = initialState.modal, action: IModalAction) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        confirmModal: {
          show: true,
          modalProps: action.payload.confirmModal.modalProps,
        },
      };
    case HIDE_MODAL:
      return {
        ...state,
        confirmModal: null,
      };
    case SHOW_NOTIFICATION:
      return {
        ...state,
        notificationModal: {
          show: true,
          data: action.payload.notificationModal.data,
        },
      };
    case HIDE_NOTIFICATION:
      return {
        ...state,
        notificationModal: null,
      };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.modal;
    default:
      return state;
  }
};

export default modalReducer;
